export const HostStatusObj = {
    "Active": 2,
    "Passive": 1,
    "Banned": 3,
}
export enum HostStatusType {
    ACTIVE = "Active",
    PASSİVE = "Passive",
    DELETED = "Deleted",
}